import 'react';
import '@grafana/data';

var QueryEditorMode = /* @__PURE__ */ ((QueryEditorMode2) => {
  QueryEditorMode2["Code"] = "code";
  QueryEditorMode2["Builder"] = "builder";
  return QueryEditorMode2;
})(QueryEditorMode || {});
const BINARY_OPERATIONS_KEY = "Binary operations";

export { BINARY_OPERATIONS_KEY, QueryEditorMode };
//# sourceMappingURL=types.js.map
